import { Component, Inject, OnInit } from '@angular/core';
import { NgStyle } from '@angular/common';

export interface IAnatomicMapTooltipInput {
    config: { top: number; left: number };
}
@Component({
    selector: 'anatomic-map-tooltip',
    templateUrl: './anatomic-map-tooltip.component.html',
    styleUrls: ['./anatomic-map-tooltip.component.scss'],
    imports: [NgStyle],
    standalone: true,
})
export class AnatomicMapTooltipComponent implements OnInit {
    top: string;
    left: string;

    constructor(@Inject('tooltipConfig') public config) {}

    ngOnInit() {
        const { top, left } = this.config;
        this.top = `${top}px`;
        this.left = `${left}px`;
    }
}
